export default __webpack_public_path__ + "static/media/eyeClose.c8d86b6a.svg";